import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
//import { LoggingService } from '@tmhcc-ng-lib/framwork/logging';
import { createGuid } from '@tmhcc/util';
import { LoaderService } from '@tmhcc-ng-lib/framwork/loader';
import { ErrorService } from './error.service';
import { AlertTosterService } from '@tmhcc/framwork/alert-toster';

@Injectable()
export class ErrorHandlerService implements ErrorHandler {
  constructor(private injector: Injector) {}

  handleError(error: HttpErrorResponse) {
    const loader = this.injector.get(LoaderService);
    const errorService = this.injector.get(ErrorService);
    const notifier = this.injector.get(AlertTosterService);

    let message;
    let stackTrace;

    if (error instanceof HttpErrorResponse) {
      // Server Error
      message = errorService.getServerMessage(error);
      stackTrace = errorService.getServerStack(error);
    } else {
      // Client Error
      message = errorService.getClientMessage(error);
      stackTrace = errorService.getClientStack(error);
    }
    loader.hide();
    // notifier.error('Something went wrong, please try again.');

    let prop = {
      Tenant: 'TMHHC CLAIM',
      ErrorId: createGuid(),
      ApplicationPlatform: 'Web.Frontend',
      Component: '',
      Method: ''
    };    
  }
}
